// @ts-strict-ignore
/* eslint-disable no-magic-numbers */
import { getModuleFromIncludes } from '../redux/contentful-selectors'
import { contentId } from './contentful'

/** Version of deep merge specifically made for merging product tables.
 * It will keep array indexes and override in the same place rather than pushing new array elements
 */

function productDeepMerge(a, b) {
  if (typeof b !== 'object') {
    return a
  }
  if (a === undefined) {
    // Setup default value for a if we're starting from an undefined object
    if (Array.isArray(b)) {
      a = []
    } else {
      a = {}
    }
  }
  if (typeof a !== 'object' || typeof b !== 'object') {
    return a
  }
  // Logic has to be different for arrays and objects due to the `delete` keyword
  let result
  if (Array.isArray(a)) {
    result = [...a]
    for (let key = b.length - 1; key >= 0; key--) {
      // Delete is the keyword to remove elements from the product table
      if (b[key] === 'delete') {
        result.splice(key, 1)
      } else {
        mergeKey(result, key, a, b)
      }
    }
  } else {
    result = { ...a }
    for (const key in b) {
      if (b[key] === 'delete') {
        delete result[key]
      } else {
        mergeKey(result, key, a, b)
      }
    }
  }
  return result
}

function mergeKey(result, key, a, b) {
  if (typeof a[key] === 'object') {
    result[key] = productDeepMerge(a[key], b[key])
  } else {
    result[key] = b[key]
  }
}

/** Given a product table schema, processes deep merging of any base table schema to generate the final table object */
export function processProductTableSchema(includes, schemaComp) {
  if (schemaComp.fields.baseSchema) {
    const baseSchemaId = contentId(schemaComp.fields.baseSchema)
    // Added recursivity to support base product table schemas that also use another level of base table
    const baseSchemaComp = getModuleFromIncludes(includes, baseSchemaId)
    if (baseSchemaComp.fields === undefined) {
      return schemaComp
    }
    const baseSchema = processProductTableSchema(includes, baseSchemaComp)
    const newSchema = productDeepMerge(baseSchema.fields.schema, schemaComp.fields.schema)
    const newComp = {
      ...schemaComp,
      fields: {
        ...schemaComp.fields,
        schema: newSchema,
      },
    }
    return newComp
  }
  return schemaComp
}
